import React, { useState, useEffect, useCallback } from 'react';
import './AdminFormacionesGratis.css';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/formaciones_gratis.php';
const APP_URL = 'https://centrocomunicar.com';

/* ── Icons ── */
const IconRefresh  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconPlus     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconEdit     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUsers    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M16 3.13a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconLink     = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconStar     = () => (<svg viewBox="0 0 24 24" fill="#f59e0b" width="13" height="13"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const IconToggle   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><rect x="1" y="5" width="22" height="14" rx="7" stroke="currentColor" strokeWidth="2"/><circle cx="16" cy="12" r="4" fill="currentColor"/></svg>);
const IconDownload = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="7 10 12 15 17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCopy     = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconPlay     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M10 8l6 4-6 4V8z" fill="currentColor"/></svg>);

const TIPOS = ['video','pdf','clase','webinar','recurso'];
const TIPO_LABEL = { video:'🎥 Video', pdf:'📄 PDF', clase:'🎓 Clase', webinar:'📡 Webinar', recurso:'📦 Recurso' };
const CATEGORIAS = ['Lenguaje','TEA','Habla','Aprendizaje','Familia','General'];
const NIVELES = ['todos','basico','intermedio','avanzado'];
const FUENTES = [
  { key:'instagram', label:'Instagram' },
  { key:'whatsapp',  label:'WhatsApp'  },
  { key:'qr',        label:'QR'        },
];

function fmtFecha(str) {
  if (!str) return '—';
  return new Date(str).toLocaleDateString('es-PE', { day:'2-digit', month:'short', year:'numeric' });
}

const FORM_VACIO = {
  titulo:'', descripcion:'', descripcion_larga:'', tipo:'video',
  categoria:'Lenguaje', nivel:'todos', duracion:'', instructor:'',
  imagen_url:'', archivo_url:'', video_url:'', link_externo:'',
  temario:[], utm_campaign:'', destacado:false, slug:'',
};

export default function AdminFormacionesGratis() {
  const [items,    setItems]    = useState([]);
  const [loading,  setLoading]  = useState(false);
  const [toast,    setToast]    = useState(null);

  // Modal principal (crear/editar)
  const [modal,    setModal]    = useState(null); // null | 'crear' | 'editar'
  const [form,     setForm]     = useState(FORM_VACIO);
  const [guardando,setGuardando]= useState(false);

  // Modal inscritos
  const [modalIns, setModalIns] = useState(null);
  const [inscritos,setInscritos]= useState([]);
  const [loadIns,  setLoadIns]  = useState(false);

  // Temario (lista de strings)
  const [nuevoTema, setNuevoTema] = useState('');

  const showToast = (msg, tipo='ok') => { setToast({msg,tipo}); setTimeout(()=>setToast(null),3000); };

  /* Fetch */
  const fetchItems = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}?action=list&activo=0`);
      const j = await r.json();
      if (j.success) setItems(j.data || []);
    } catch(e) { showToast('Error cargando formaciones','error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchItems(); }, [fetchItems]);

  /* Abrir editar */
  const abrirEditar = (item) => {
    setForm({
      ...FORM_VACIO, ...item,
      temario: item.temario ? (Array.isArray(item.temario) ? item.temario : []) : [],
      destacado: !!item.destacado,
    });
    setModal('editar');
  };

  /* Guardar */
  const guardar = async () => {
    if (!form.titulo.trim()) { showToast('El título es obligatorio','error'); return; }
    setGuardando(true);
    try {
      const action = modal === 'crear' ? 'crear' : 'editar';
      const r = await fetch(`${API}?action=${action}`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ ...form, temario: form.temario }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(modal === 'crear' ? 'Formación creada' : 'Formación actualizada');
      setModal(null);
      fetchItems();
    } catch(err) { showToast(err.message, 'error'); }
    finally { setGuardando(false); }
  };

  /* Toggle activo */
  const toggleActivo = async (item) => {
    try {
      const r = await fetch(`${API}?action=toggle_activo`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ id: item.id, activo: item.activo ? 0 : 1 }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(item.activo ? 'Desactivada' : 'Activada');
      fetchItems();
    } catch(err) { showToast(err.message, 'error'); }
  };

  /* Ver inscritos */
  const verInscritos = async (item) => {
    setModalIns(item);
    setInscritos([]);
    setLoadIns(true);
    try {
      const r = await fetch(`${API}?action=inscritos_list&formacion_id=${item.id}`);
      const j = await r.json();
      if (j.success) setInscritos(j.data || []);
    } catch(e) {}
    finally { setLoadIns(false); }
  };

  /* Copiar link */
  const copiarLink = (item, fuente) => {
    const url = `${APP_URL}/formaciones-gratis/${item.slug}?utm_source=${fuente}&utm_campaign=${item.utm_campaign||item.slug}`;
    navigator.clipboard.writeText(url).then(() => showToast('Link copiado'));
  };

  /* Temario */
  const agregarTema = () => {
    if (!nuevoTema.trim()) return;
    setForm(f=>({...f, temario:[...f.temario, nuevoTema.trim()]}));
    setNuevoTema('');
  };
  const quitarTema = (i) => setForm(f=>({...f, temario:f.temario.filter((_,idx)=>idx!==i)}));

  /* KPIs */
  const totalActivos   = items.filter(i=>i.activo).length;
  const totalInscritos = items.reduce((a,i)=>a+(parseInt(i.total_inscritos||0)),0);
  const totalDest      = items.filter(i=>i.destacado).length;

  return (
    <div className="afg-page">
      {toast && (
        <div className={`afg-toast afg-toast--${toast.tipo}`}>
          {toast.tipo==='ok'?<IconCheck/>:<IconClose/>} {toast.msg}
        </div>
      )}

      {/* HEADER */}
      <div className="afg-header">
        <div>
          <h1>Formaciones Gratuitas</h1>
          <p>Crea y gestiona formaciones gratuitas con inscripción</p>
        </div>
        <div className="afg-header__actions">
          <button className="afg-btn-ghost" onClick={fetchItems}><IconRefresh/> Actualizar</button>
          <button className="afg-btn-primary" onClick={()=>{ setForm(FORM_VACIO); setModal('crear'); }}>
            <IconPlus/> Nueva formación
          </button>
        </div>
      </div>

      {/* KPIs */}
      <div className="afg-kpis">
        <div className="afg-kpi afg-kpi--verde">
          <div className="afg-kpi__icon"><IconPlay/></div>
          <p>Activas</p><strong>{loading?'…':totalActivos}</strong>
          <span>de {items.length} formaciones</span>
        </div>
        <div className="afg-kpi">
          <div className="afg-kpi__icon afg-kpi__icon--azul"><IconUsers/></div>
          <p>Total inscritos</p><strong>{loading?'…':totalInscritos}</strong>
          <span>inscripciones recibidas</span>
        </div>
        <div className="afg-kpi">
          <div className="afg-kpi__icon afg-kpi__icon--amarillo"><IconStar/></div>
          <p>Destacadas</p><strong>{loading?'…':totalDest}</strong>
          <span>aparecen primero</span>
        </div>
      </div>

      {/* GRID */}
      {loading ? (
        <div className="afg-loading"><div className="afg-spinner"/> Cargando…</div>
      ) : items.length === 0 ? (
        <div className="afg-empty">
          <p>Aún no hay formaciones gratuitas.</p>
          <button className="afg-btn-primary" onClick={()=>{ setForm(FORM_VACIO); setModal('crear'); }}>
            <IconPlus/> Crear primera formación
          </button>
        </div>
      ) : (
        <div className="afg-grid">
          {items.map(item => (
            <div className={`afg-card ${!item.activo?'afg-card--inactiva':''} ${item.destacado?'afg-card--destacada':''}`} key={item.id}>
              {/* Head */}
              <div className="afg-card__head">
                <div className="afg-card__badges">
                  <span className={`afg-badge afg-badge--tipo`}>{TIPO_LABEL[item.tipo]||item.tipo}</span>
                  {item.destacado && <span className="afg-badge afg-badge--dest"><IconStar/> Destacada</span>}
                  <span className={`afg-badge ${item.activo?'afg-badge--activa':'afg-badge--inactiva'}`}>
                    {item.activo?'● Activa':'○ Inactiva'}
                  </span>
                </div>
                <div className="afg-card__actions-top">
                  <button onClick={()=>abrirEditar(item)} title="Editar"><IconEdit/></button>
                  <button onClick={()=>verInscritos(item)} title="Ver inscritos">
                    <IconUsers/>
                    {item.total_inscritos > 0 && (
                      <span className="afg-card__badge-num">{item.total_inscritos}</span>
                    )}
                  </button>
                  <button onClick={()=>toggleActivo(item)} title={item.activo?'Desactivar':'Activar'}>
                    <IconToggle/>
                  </button>
                </div>
              </div>

              {/* Body */}
              <div className="afg-card__body">
                {item.categoria && <span className="afg-card__cat">{item.categoria.toUpperCase()}</span>}
                <h3>{item.titulo}</h3>
                {item.descripcion && <p>{item.descripcion}</p>}
                <div className="afg-card__meta">
                  {item.duracion   && <span>⏱ {item.duracion}</span>}
                  {item.instructor && <span>👤 {item.instructor}</span>}
                  {item.nivel !== 'todos' && <span>📊 {item.nivel}</span>}
                </div>
              </div>

              {/* Stats */}
              <div className="afg-card__stats">
                <div className="afg-stat"><strong>{item.total_inscritos||0}</strong><span>inscritos</span></div>
                <div className="afg-stat"><strong>{fmtFecha(item.created_at)}</strong><span>creada</span></div>
              </div>

              {/* Links captación */}
              <div className="afg-card__links">
                <p className="afg-card__links-title">Links de captación:</p>
                {FUENTES.map(f=>(
                  <div className="afg-link-row" key={f.key}>
                    <span>{f.label}</span>
                    <button className="afg-copy-btn" onClick={()=>copiarLink(item,f.key)}>
                      <IconCopy/> Copiar
                    </button>
                  </div>
                ))}
              </div>

              {/* Archivos */}
              {(item.video_url || item.archivo_url || item.link_externo) && (
                <div className="afg-card__files">
                  {item.video_url && (
                    <a href={item.video_url} target="_blank" rel="noopener noreferrer" className="afg-file-btn afg-file-btn--video">
                      <IconPlay/> Ver video
                    </a>
                  )}
                  {item.archivo_url && (
                    <a href={item.archivo_url} target="_blank" rel="noopener noreferrer" className="afg-file-btn afg-file-btn--pdf">
                      <IconDownload/> Ver archivo
                    </a>
                  )}
                  {item.link_externo && (
                    <a href={item.link_externo} target="_blank" rel="noopener noreferrer" className="afg-file-btn afg-file-btn--link">
                      <IconLink/> Link externo
                    </a>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* ══ MODAL CREAR/EDITAR ══ */}
      {modal && (
        <div className="afg-overlay" onClick={()=>setModal(null)}>
          <div className="afg-modal afg-modal--lg" onClick={e=>e.stopPropagation()}>
            <div className="afg-modal__head">
              <h2>{modal==='crear'?'Nueva formación gratuita':'Editar formación'}</h2>
              <button className="afg-modal__close" onClick={()=>setModal(null)}><IconClose/></button>
            </div>

            <div className="afg-modal__body">
              <div className="afg-form-grid">

                {/* Título */}
                <div className="afg-field afg-field--full">
                  <label>Título *</label>
                  <input type="text" placeholder="Ej: Introducción a la evaluación del lenguaje"
                    value={form.titulo} onChange={e=>setForm(f=>({...f,titulo:e.target.value}))}/>
                </div>

                {/* Descripción corta */}
                <div className="afg-field afg-field--full">
                  <label>Descripción corta</label>
                  <input type="text" placeholder="Una línea descriptiva…"
                    value={form.descripcion} onChange={e=>setForm(f=>({...f,descripcion:e.target.value}))}/>
                </div>

                {/* Descripción larga */}
                <div className="afg-field afg-field--full">
                  <label>Descripción larga</label>
                  <textarea rows="3" placeholder="Descripción detallada para la página de detalle…"
                    value={form.descripcion_larga} onChange={e=>setForm(f=>({...f,descripcion_larga:e.target.value}))}/>
                </div>

                {/* Tipo */}
                <div className="afg-field">
                  <label>Tipo</label>
                  <select value={form.tipo} onChange={e=>setForm(f=>({...f,tipo:e.target.value}))}>
                    {TIPOS.map(t=><option key={t} value={t}>{TIPO_LABEL[t]}</option>)}
                  </select>
                </div>

                {/* Categoría */}
                <div className="afg-field">
                  <label>Categoría</label>
                  <select value={form.categoria} onChange={e=>setForm(f=>({...f,categoria:e.target.value}))}>
                    {CATEGORIAS.map(c=><option key={c} value={c}>{c}</option>)}
                  </select>
                </div>

                {/* Nivel */}
                <div className="afg-field">
                  <label>Nivel</label>
                  <select value={form.nivel} onChange={e=>setForm(f=>({...f,nivel:e.target.value}))}>
                    {NIVELES.map(n=><option key={n} value={n}>{n}</option>)}
                  </select>
                </div>

                {/* Duración */}
                <div className="afg-field">
                  <label>Duración</label>
                  <input type="text" placeholder="Ej: 1h 30min"
                    value={form.duracion} onChange={e=>setForm(f=>({...f,duracion:e.target.value}))}/>
                </div>

                {/* Instructor */}
                <div className="afg-field">
                  <label>Instructor</label>
                  <input type="text" placeholder="Ej: Equipo Comunicar"
                    value={form.instructor} onChange={e=>setForm(f=>({...f,instructor:e.target.value}))}/>
                </div>

                {/* URLs */}
                <div className="afg-field afg-field--full">
                  <label>URL de video (YouTube, Vimeo…)</label>
                  <input type="url" placeholder="https://youtube.com/watch?v=..."
                    value={form.video_url} onChange={e=>setForm(f=>({...f,video_url:e.target.value}))}/>
                </div>
                <div className="afg-field">
                  <label>URL archivo / PDF</label>
                  <input type="url" placeholder="https://..."
                    value={form.archivo_url} onChange={e=>setForm(f=>({...f,archivo_url:e.target.value}))}/>
                </div>
                <div className="afg-field">
                  <label>Link externo</label>
                  <input type="url" placeholder="https://..."
                    value={form.link_externo} onChange={e=>setForm(f=>({...f,link_externo:e.target.value}))}/>
                </div>
                <div className="afg-field">
                  <label>Imagen (URL)</label>
                  <input type="url" placeholder="https://..."
                    value={form.imagen_url} onChange={e=>setForm(f=>({...f,imagen_url:e.target.value}))}/>
                </div>
                <div className="afg-field">
                  <label>UTM Campaign</label>
                  <input type="text" placeholder="Auto-generado del slug si se deja vacío"
                    value={form.utm_campaign} onChange={e=>setForm(f=>({...f,utm_campaign:e.target.value}))}/>
                </div>

                {/* Slug */}
                {modal==='crear' && (
                  <div className="afg-field afg-field--full">
                    <label>Slug <span style={{fontWeight:400,color:'var(--gris)'}}>— URL amigable (auto si vacío)</span></label>
                    <input type="text" placeholder="ej: intro-evaluacion-lenguaje"
                      value={form.slug} onChange={e=>setForm(f=>({...f,slug:e.target.value}))}/>
                  </div>
                )}

                {/* Destacado */}
                <div className="afg-field afg-field--full">
                  <label className="afg-checkbox">
                    <input type="checkbox" checked={!!form.destacado}
                      onChange={e=>setForm(f=>({...f,destacado:e.target.checked}))}/>
                    <span>⭐ Formación destacada (aparece primero en la web)</span>
                  </label>
                </div>

                {/* Temario */}
                <div className="afg-field afg-field--full">
                  <label>Temario / Contenido</label>
                  <div className="afg-temario">
                    {form.temario.map((t,i)=>(
                      <div className="afg-tema" key={i}>
                        <span>{t}</span>
                        <button type="button" onClick={()=>quitarTema(i)}>✕</button>
                      </div>
                    ))}
                    <div className="afg-tema-add">
                      <input type="text" placeholder="Agregar tema o módulo…"
                        value={nuevoTema} onChange={e=>setNuevoTema(e.target.value)}
                        onKeyDown={e=>e.key==='Enter'&&(e.preventDefault(),agregarTema())}/>
                      <button type="button" onClick={agregarTema}><IconPlus/></button>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="afg-modal__foot">
              <button className="afg-btn-ghost" onClick={()=>setModal(null)}>Cancelar</button>
              <button className="afg-btn-primary" onClick={guardar} disabled={guardando}>
                {guardando?<><span className="afg-spinner-sm"/>Guardando…</>:<><IconCheck/> {modal==='crear'?'Crear formación':'Guardar cambios'}</>}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ══ MODAL INSCRITOS ══ */}
      {modalIns && (
        <div className="afg-overlay" onClick={()=>setModalIns(null)}>
          <div className="afg-modal" onClick={e=>e.stopPropagation()}>
            <div className="afg-modal__head">
              <div>
                <h2>Inscritos</h2>
                <p style={{fontSize:'.82rem',color:'var(--gris)',marginTop:'.2rem'}}>{modalIns.titulo}</p>
              </div>
              <button className="afg-modal__close" onClick={()=>setModalIns(null)}><IconClose/></button>
            </div>
            <div className="afg-modal__body">
              {loadIns ? (
                <div className="afg-loading"><div className="afg-spinner"/> Cargando…</div>
              ) : inscritos.length === 0 ? (
                <div className="afg-empty-sm">Aún no hay inscritos en esta formación.</div>
              ) : (
                <div className="afg-inscritos">
                  {inscritos.map((ins,i)=>(
                    <div className="afg-inscrito" key={i}>
                      <div className="afg-inscrito__avatar">{(ins.nombre||'?')[0].toUpperCase()}</div>
                      <div className="afg-inscrito__info">
                        <strong>{ins.nombre}</strong>
                        <span>{ins.email}</span>
                        {ins.telefono && <span>{ins.telefono}</span>}
                      </div>
                      <div className="afg-inscrito__meta">
                        <span className={`afg-badge afg-badge--${ins.perfil==='profesional'?'verde':ins.perfil==='familia'?'azul':'gris'}`}>{ins.perfil}</span>
                        <span style={{fontSize:'.72rem',color:'var(--gris)'}}>{ins.fecha}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="afg-modal__foot">
              <span style={{fontSize:'.82rem',color:'var(--gris)'}}>{inscritos.length} inscritos</span>
              <button className="afg-btn-ghost" onClick={()=>setModalIns(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}